import { Component, OnInit } from '@angular/core';
import { ApiRestService } from "../api-rest.service";
import { Materiale } from "../_Models/materiale";
import { ServerPaginationService } from "../../shared/_services/server-pagination.service";
import { ActivatedRoute, Router } from "@angular/router";
import { ClassicType } from "../../shared/models/ClassicType";
import { Azienda } from "../../Admin/models/Azienda";
import { ApiRestService as ClientiApiRestService } from "../../Admin/_service/api-rest.service";
import { IDropdownSettings } from 'src/LibrerieCustom/MultiselectDropdown/public_api';
import { ToastrService } from "ngx-toastr";
import { ApiPathsService } from "../../api-paths.service";
import { DownloadService } from "../../shared/_services/download.service";
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-materiali-list',
  templateUrl: './materiali-list.component.html',
  styleUrls: ['./materiali-list.component.css']
})
export class MaterialiListComponent implements OnInit {
  environment = environment;
  page = 1;
  pageSize: number = 50;
  pagesizeserver = 4; // pagine da precaricare dal server
  newpagegenerated: number = 1;
  showAll: boolean = false;
  public SelectAll: boolean;
  Materiali: Materiale[] = [];
  Tipo: string;
  Tipi: ClassicType[] = [];
  TipiSelezionati: ClassicType[] = [];
  title: string = "";
  SelectedPage = 1;
  private sel_cat_id: number;
  clientiDropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    idField: 'id',
    textField: 'nominativo',
    allowSearchFilter: true,
    singleOutput: true
  };
  filtroFornitoriDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    closeDropDownOnSelection: false,
    idField: 'id',
    textField: 'nominativo',
    allowSearchFilter: true,
    singleOutput: false
  };
  FornitoriFiltro: Azienda[] = [];
  Fornitori: Azienda[] = [];
  ValoreMagazzino: any;
  Totale: number;
  filtri: any = {};
  constructor(
    private apiRest: ApiRestService,
    private paginationService: ServerPaginationService,
    private route: ActivatedRoute,
    public router: Router,
    private clientiApiRest: ClientiApiRestService,
    private toastrService: ToastrService,
    private apiPaths: ApiPathsService,
    private downloadService: DownloadService
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(routedata => {
      this.sel_cat_id = parseInt(routedata['cat']) ?? undefined;
      this.apiRest.getPartiTypes().subscribe(data => {
        this.Tipo = !routedata['type'] ? data[0]?.id?.toString() : routedata['type'];
        this.Tipi = data;
        this.title = data.find(x => x.id.toString() == this.Tipo.toString())?.label ?? '';
        this.Refresh();
      })
    });
  }

  Refresh(pagina?) {
    this.clientiApiRest.getListaAziende({ ruolo: "F", page: 0, size: 10 }).subscribe(data => {
      this.Fornitori = data?.data;

    });
    this.filtri.fornitori = this.FornitoriFiltro?.map(x => x.id) ?? [];
    var filter = Object.assign({}, this.filtri, { page: ((pagina ?? 1) - 1) / this.pagesizeserver + 1, size: this.pagesizeserver * this.pageSize, tipo: parseInt(this.Tipo ?? '0'), cat_id: this.sel_cat_id });
    this.apiRest.GetParti(filter).subscribe(data => {
      this.Materiali = data.data;
      this.ValoreMagazzino = data.valore;
      this.Totale = data.total;
      console.log(data);
    }, () => {
      this.router.navigate([`materiali/list/${this.Tipo?.toString()}`]).then();
    })
  }

  showDeleted() {
    this.showAll = !this.showAll;
    this.Refresh(1);
  }
  getPage(page: number) {
    this.page = this.paginationService.paginadellalista(page, this.pagesizeserver);
    const pagetosend = this.paginationService.getPage(page, this.newpagegenerated, this.pagesizeserver);
    if ((pagetosend - 1) % this.pagesizeserver === 0) {
      this.newpagegenerated = page;
      this.Refresh(pagetosend);
    }
  }

  edit(materiale?: Materiale, blank: boolean = false) {
    var url = `materiali/edit/${this.Tipo}/${materiale?.id}`;
    if(!blank)
    this.router.navigate([url]);
    else 
      window.open(url, "_blank");
  }
  

  delete(materiale: Materiale) {
    if (!materiale?.id || !confirm("Sei sicuro di voler eliminare questo elemento dalla lista?")) return;
    this.apiRest.deleteParti(materiale).subscribe(() => this.Refresh(this.newpagegenerated));

  }

  FornitoreChange(fornitore: Azienda, materiale: Materiale) {
    materiale.fornitore = fornitore?.id
  }

  Ordina() {
    var selected: Materiale[] = this.Materiali?.filter(x => x.isSelected);
    if (!selected || selected.length <= 0) {
      this.toastrService.warning("Nessun Elemento selezionato.")
      return;
    } else {
      this.apiPaths.FilePost('/primanota/acquisti/new', { voci: selected?.map(x => ({ parte_id: x.id, quantita: x.quantita, fornitore: x.fornitore })) }).subscribe(data => {
        this.toastrService.success("Ordine effettuato con successo")
        this.Refresh(1);
        this.downloadService.downloadFile(data)

      })
    }
  }
  checkUncheckAll() {
    this.Materiali?.forEach(materiale => {
      materiale.isSelected = this.SelectAll
      if (this.SelectAll) {
        var def = (materiale.scortaMin - materiale.magazzino) > 0 ? materiale.scortaMin - materiale.magazzino : 10
        materiale.quantita = !materiale.quantita || materiale.quantita >= 0 ? def : materiale.quantita;
      }
    })
  }

  CheckIfAllSelected() {
    this.SelectAll = this.Materiali.every(function (item: any) {
      return item.isSelected == true;
    })
  }

  ToggleItem(materiale: Materiale) {
    var def = (materiale.scortaMin - materiale.magazzino) > 0 ? materiale.scortaMin - materiale.magazzino : 10
    materiale.quantita = !materiale.quantita || materiale.quantita >= 0 ? def : materiale.quantita;
    this.CheckIfAllSelected();
  }

  QuantitaChange(materiale: Materiale) {
    materiale.isSelected = materiale.quantita > 0;
    this.CheckIfAllSelected();
  }

  duplica(materiale: Materiale) {
    this.apiPaths.ClassicPost("/prodotti/parti/copia", { id: materiale.id }).subscribe(() => {
      this.Refresh();
    })
  }

  Stampa() {
    this.apiPaths.FileGet(`/prodotti/parti/export/${this.title.toLowerCase()}`).subscribe((data) => {
      this.downloadService.downloadFile(data);
    }
    )
  }
}
